import cloneDeep from 'lodash.clonedeep';

import {
  Model,
  ModelData,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';

export const createDraftData = (
  model: ModelSnapshot | Model
): NonNullable<ModelData['draftData']> => {
  const originalSpgNamesByCurrentName = Object.keys(
    model.modelData.sensitivePropertyGroupsByName
  ).reduce<Record<string, string>>((acc, spgName) => {
    acc[spgName] = spgName;
    return acc;
  }, {});

  return {
    prevNodeDataArray: cloneDeep(model.nodeDataArray),
    prevLinkDataArray: cloneDeep(model.linkDataArray),
    prevModelData: cloneDeep(model.modelData),
    originalSpgNamesByCurrentName,
  };
};
